/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Activeeventscount2Inputs */

const en_activeeventscount2 = /** @type {(inputs: Activeeventscount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parallel active events`)
};

const de_activeeventscount2 = /** @type {(inputs: Activeeventscount2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} parallel aktive Events`)
};

/**
* | output |
* | --- |
* | "{count} parallel active events" |
*
* @param {Activeeventscount2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const activeeventscount2 = /** @type {((inputs: Activeeventscount2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Activeeventscount2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_activeeventscount2(inputs)
	return de_activeeventscount2(inputs)
});
export { activeeventscount2 as "activeEventsCount" }